import { Component } from '@angular/core';
import { DeviceProvider } from '../../providers/device/device';
import { AuthProvider } from '@providers/auth/auth';

@Component({
  selector: 'modal-version-app',
  templateUrl: 'modal-version-app.html',
  providers: [ DeviceProvider ]
})
export class ModalVersionAppComponent {

  checkVersion: any = {
    newVersion: false
  };
  showModal: boolean = false;
  linkStore: string;

  constructor(
    private authProvider: AuthProvider,
    private deviceProvider: DeviceProvider
  ) {

    this.deviceProvider.checkNewVersion()
      .then( response => {
        this.checkVersion = response;
        return this.authProvider.mostrarModalVersion();
      })
      .then( (mostrarModalVersion: number) => {
        if(this.checkVersion.newVersion === true) {
          this.showModal = true;
          return this.authProvider.setMostrarModalVersion(0);
        }

        if(this.checkVersion.newVersion === false && +mostrarModalVersion === 0) {
          this.showModal = true;
          return this.authProvider.setMostrarModalVersion(1);
        }
      })
      .then( _ => {
        let url = this.deviceProvider.generaURLStore();
        this.linkStore = url;
      })
      .catch(e => console.log(e));
  }

  close() {
    this.showModal = !this.showModal;
  }

  store() {
    let url = this.deviceProvider.generaURLStore();
    window.open(url);
  }
}



// WEBPACK FOOTER //
// ./src/components/modal-version-app/modal-version-app.ts